function canSendPixel(): boolean {
  if (typeof window === 'undefined' || !window.fbq) return false;
  if (navigator.webdriver) return false;
  return true;
}

export function readMetaBrowserContext(): {
  fbp?: string;
  fbc?: string;
  eventSourceUrl?: string;
} {
  if (typeof document === 'undefined') return {};
  const readCookie = (name: string) => {
    const row = document.cookie.split('; ').find((item) => item.startsWith(`${name}=`));
    if (!row) return undefined;
    const value = decodeURIComponent(row.slice(name.length + 1)).trim();
    return value || undefined;
  };
  let fbc = readCookie('_fbc');
  if (!fbc) {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
  }
  return {
    fbp: readCookie('_fbp'),
    fbc,
    eventSourceUrl: window.location.href.slice(0, 1000),
  };
}

export function trackPageView(): void {
  if (!canSendPixel()) return;
  window.fbq!('track', 'PageView');
}

export function trackViewContent(params: {
  contentName?: string;
  contentIds?: string[];
  value?: number;
  currency?: string;
}): void {
  if (!canSendPixel()) return;
  window.fbq!('track', 'ViewContent', {
    content_name: params.contentName,
    content_ids: params.contentIds,
    content_type: 'product',
    value: params.value,
    currency: params.currency || 'BRL',
  });
}

export function trackAddToCart(params?: {
  contentIds?: string[];
  contentName?: string;
  value?: number;
  currency?: string;
  numItems?: number;
}): void {
  if (!canSendPixel()) return;
  window.fbq!('track', 'AddToCart', {
    content_ids: params?.contentIds,
    content_name: params?.contentName,
    content_type: 'product',
    value: params?.value,
    currency: params?.currency || 'BRL',
    num_items: params?.numItems,
  });
}

export function trackInitiateCheckout(params?: {
  contentIds?: string[];
  value?: number;
  currency?: string;
  numItems?: number;
}): void {
  if (!canSendPixel()) return;
  window.fbq!('track', 'InitiateCheckout', {
    content_ids: params?.contentIds,
    content_type: 'product',
    value: params?.value,
    currency: params?.currency || 'BRL',
    num_items: params?.numItems,
  });
}

export function trackAddPaymentInfo(params?: {
  contentIds?: string[];
  value?: number;
  currency?: string;
}): void {
  if (!canSendPixel()) return;
  window.fbq!('track', 'AddPaymentInfo', {
    content_ids: params?.contentIds,
    content_type: 'product',
    value: params?.value,
    currency: params?.currency || 'BRL',
  });
}

/** eventId igual ao do servidor (pedido ou inscrição) para a Meta não contar duas vezes. */
export function trackPurchase(params: {
  value: number;
  currency?: string;
  contentIds?: string[];
  numItems?: number;
  eventId?: string;
}): void {
  if (!canSendPixel()) return;
  window.fbq!(
    'track',
    'Purchase',
    {
      value: Number(params.value) || 0,
      currency: params.currency || 'BRL',
      content_ids: params.contentIds,
      content_type: 'product',
      num_items: params.numItems,
    },
    params.eventId ? { eventID: params.eventId } : undefined
  );
}
